export default __webpack_public_path__ + "static/media/one-time-link.5b44c16d.png";